import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      '& .reassignInspectorLabel': {
        lineHeight: '120%',
        letterSpacing: '0.15px',
        paddingBottom: 4,
      },
    },
    nameLabel: {
      letterSpacing: '0.25px',
      paddingTop: '4px',
    },
    divider: {
      backgroundColor: 'rgba(255, 255, 255, 0.40)',
      width: '100%',
      margin: '12px 0px',
    },
    plusIcon: {
      marginRight: 9.67,
      height: 20,
      width: 20,
      cursor: 'pointer',
    },
    searchIcon: {
      height: 20,
      width: 20,
    },
    commentPadding: {
      padding: '16px 0px',
    },
    leadInspectorName: {
      letterSpacing: '0.25px',
      margin: '12px 0px 4px 0px !important',
    },
  }),
);
export default useStyles;
